module.exports = __webpack_public_path__ + "img/ballkani-logo-icon.7115428c.png";